import React, { useCallback } from 'react';
import { ePermissions } from '../../../../types/administration/userAdministration/ePermissions';
import { ButtonDropdown } from 'ui-toolkit';
import { IFeatureData } from '../../../../types/administration/features/IFeature';
import { RedGreenOptions } from '../../subComponents/RedGreenOptions';
import { faBolt, faBoltSlash } from '@fortawesome/pro-regular-svg-icons';
import { PermissionWrapper } from '../../../accessControl/PermissionWrapper';
import { useUpdateFeatureMutation } from '../../../../API/administration/FeaturesAPI';
import { checkForMutationSuccess } from '../../../../API/checkForMutationSuccess';

interface IFeatureMenuDropdownProps {
  feature: IFeatureData;
}

export const FeatureMenuDropdown: React.FC<IFeatureMenuDropdownProps> = ({ feature }) => {
  const [updateFeature] = useUpdateFeatureMutation();
  const handlesUpdateFeatureClick = useCallback(async () => {
    // Prevent action if feature is not editable
    if (!feature.isEditable) {
      return;
    }
    const response = await updateFeature({ name: feature.name, isOn: !feature.isOn });
    checkForMutationSuccess(response, `Updated Feature ${feature.name} to ${feature.isOn ? 'OFF' : 'ON'}`);
  }, [feature, updateFeature]);

  return (
    <PermissionWrapper allowedPermissions={[ePermissions.FeatureEdit]}>
      <ButtonDropdown
        intent={'ghost'}
        disabled={!feature.isEditable}
        children={<RedGreenOptions isEnabled={feature.isOn} activeIcon={faBolt} inactiveIcon={faBoltSlash} />}
        items={[
          {
            children: <RedGreenOptions isEnabled={feature.isOn} activeIcon={faBolt} inactiveIcon={faBoltSlash} />,
            onClick: handlesUpdateFeatureClick,
          },
        ]}
      />
    </PermissionWrapper>
  );
};
